import { useServiceCategory, useServiceName } from '@consigli/hooks';
import { ServiceCategory } from '@consigli/types';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { HiOutlineEnvelope } from 'react-icons/hi2';

import { isAnalysisPreviewService } from '@/features/package-creation/components/analysis-preview/analysis-preview-steps';

export const WaitingForAnalysis: FC = () => {
  const { t } = useTranslation();
  const serviceName = useServiceName();
  const serviceCategory = useServiceCategory();

  if (isAnalysisPreviewService(serviceName)) {
    return (
      <div className="flex items-center justify-center h-full w-full px-4 py-12">
        <section
          aria-labelledby="analysis-waiting-title"
          className="flex w-full max-w-[560px] flex-col items-center gap-6 rounded-2xl bg-day-light-5 px-8 py-10 text-center shadow-sm"
        >
          <span
            aria-hidden
            className="flex h-12 w-12 items-center justify-center rounded-lg bg-day-light-3"
          >
            <HiOutlineEnvelope size={24} className="text-day-neutral-dark" />
          </span>
          <div className="flex flex-col gap-2">
            <h1 id="analysis-waiting-title" className="text-xl font-semibold text-day-neutral-dark">
              {t('analysis-waiting.title')}
            </h1>
            <p className="text-sm text-day-neutral-subtle">{t('analysis-waiting.description')}</p>
          </div>
        </section>
      </div>
    );
  }

  const message =
    serviceCategory === ServiceCategory.LAYOUT_OPTIMIZATION
      ? t('dashboard.waiting-for-analysis-optimization', {
          serviceName: t(`services.${serviceName}`),
        })
      : t('dashboard.waiting-for-analysis-insight');

  return (
    <div className="flex items-center justify-center h-full w-full">
      <p className="w-[400px] font-semibold text-day-neutral-dark text-center">{message}</p>
    </div>
  );
};
